var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g(_vm._b({staticClass:"Button",class:{ disabled: _vm.disabled },style:(_vm.color ? { '--color': _vm.color } : {'--color': 'var(--clrTheme)' }),attrs:{"href":"javascript: void(0)"},on:{"click":_vm.onClick}},'a',_vm.$attrs,false),_vm.listeners),[(_vm.icon)?_c('i',{class:( _obj = {}, _obj[("icon-" + _vm.icon)] = !!_vm.icon, _obj )}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }